export const typeDNI = {
  DNI: 'DNI',
  PASAPORTE: 'Pasaporte',
};

export const documentTypeOptions = [
  { label: 'DNI', formikValue: 'DNI', backendValue: '1' },
  { label: 'Pasaporte', formikValue: 'PASAPORTE', backendValue: '1' },
];

let day = [];
for (let i = 1; i <= 31; i++) {
  day.push({
    label: i.toString().length === 1 ? `0${i.toString()}` : i.toString(),
    value: i.toString().length === 1 ? `0${i.toString()}` : i.toString(),
  });
}
export const days = day;

export const meses = [
  { label: 'Enero', value: '01' },
  { label: 'Febrero', value: '02' },
  { label: 'Marzo', value: '03' },
  { label: 'Abril', value: '04' },
  { label: 'Mayo', value: '05' },
  { label: 'Junio', value: '06' },
  { label: 'Julio', value: '07' },
  { label: 'Agosto', value: '08' },
  { label: 'Septiembre', value: '09' },
  { label: 'Octubre', value: '10' },
  { label: 'Noviembre', value: '11' },
  { label: 'Diciembre', value: '12' },
];

var year = new Date().getFullYear();
var y = [];
for (let i = parseInt(year); i >= parseInt(year) - 100; i--) {
  y.push({ label: i.toString(), value: i.toString() });
}
export const years = y;

// export const countries = [
//   { label: 'Argentina', value: 'Argentina' },
//   { label: 'Brasil', value: 'Brasil' },
//   { label: 'Chile', value: 'Chile' },
//   { label: 'Bolivia', value: 'Bolivia' },
//   { label: 'Peru', value: 'Peru' },
//   { label: 'Colombia', value: 'Colombia' },
//   { label: 'Uruguay', value: 'Uruguay' },
//   { label: 'Ecuador', value: 'Ecuador' },
// ];

// export const countriesWithPhone = [
//   { label: 'Argentina (+54)', value: '54' },
//   { label: 'Brasil (+55)', value: '55' },
//   { label: 'Chile (+56)', value: '56' },
//   { label: 'Bolivia (+591)', value: '591' },
//   { label: 'Peru (+51)', value: '51' },
//   { label: 'Colombia (+57)', value: '57' },
//   { label: 'Uruguay (+598)', value: '598' },
//   { label: 'Ecuador (+593)', value: '593' },
// ];

/*export const contactoNoviaja = {
  name: '',
  lastname: '',
  email: '',
  codePhone: '54',
  caracteristicPhone: '',
  phone: '',
};*/

export const errorContactNoViaja = {
  name: { error: false, text: '' },
  lastname: { error: false, text: '' },
  codePhone: { error: false, text: '' },
  caracteristicPhone: { error: false, text: '' },
  phone: { error: false, text: '' },
};

export const countries = [
  { label: 'Alemania', value: 'Alemania' },
  { label: 'Andorra', value: 'Andorra' },
  { label: 'Argentina', value: 'Argentina' },
  { label: 'Aruba', value: 'Aruba' },
  { label: 'Australia', value: 'Australia' },
  { label: 'Austria', value: 'Austria' },
  { label: 'Bahamas', value: 'Bahamas' },
  { label: 'Bélgica', value: 'Belgica' },
  { label: 'Belice', value: 'Belice' },
  { label: 'Bolivia', value: 'Bolivia' },
  { label: 'Brasil', value: 'Brasil' },
  { label: 'Canadá', value: 'Canada' },
  { label: 'Catar', value: 'Catar' },
  { label: 'Chile', value: 'Chile' },
  { label: 'China', value: 'China' },
  { label: 'Colombia', value: 'Colombia' },
  { label: 'Costa Rica', value: 'Costa Rica' },
  { label: 'Croacia', value: 'Croacia' },
  { label: 'Cuba', value: 'Cuba' },
  { label: 'Ecuador', value: 'Ecuador' },
  { label: 'Egipto', value: 'Egipto' },
  { label: 'España', value: 'Espana' },
  { label: 'Estados Unidos', value: 'Estados Unidos' },
  { label: 'Filipinas', value: 'Filipinas' },
  { label: 'Francia', value: 'Francia' },
  { label: 'Grecia', value: 'Grecia' },
  { label: 'Guatemala', value: 'Guatemala' },
  { label: 'Haití', value: 'Haiti' },
  { label: 'Hong Kong', value: 'Hong Kong' },
  { label: 'India', value: 'India' },
  { label: 'Irán', value: 'Iran' },
  { label: 'Irak', value: 'Iraq' },
  { label: 'Irlanda', value: 'Irlanda' },
  { label: 'Israel', value: 'Israel' },
  { label: 'Italia', value: 'Italia' },
  { label: 'Jamaica', value: 'Jamaica' },
  { label: 'Japón', value: 'Japon' },
  { label: 'Líbano', value: 'Libano' },
  { label: 'Malta', value: 'Malta' },
  { label: 'Marruecos', value: 'Marruecos' },
  { label: 'México', value: 'Mexico' },
  { label: 'Nicaragua', value: 'Nicaragua' },
  { label: 'Noruega', value: 'Noruega' },
  { label: 'Nueva Zelanda', value: 'Nueva Zelanda' },
  { label: 'Países Bajos', value: 'Paises Bajos' },
  { label: 'Panamá', value: 'Panama' },
  { label: 'Paraguay', value: 'Paraguay' },
  { label: 'Perú', value: 'Peru' },
  { label: 'Polonia', value: 'Polonia' },
  { label: 'Portugal', value: 'Portugal' },
  { label: 'Puerto Rico', value: 'Puerto Rico' },
  { label: 'Inglaterra', value: 'Inglaterra' },
  { label: 'República Dominicana', value: 'Republica Dominicana' },
  { label: 'Rusia', value: 'Rusia' },
  { label: 'Sudáfrica', value: 'Sudafrica' },
  { label: 'Suecia', value: 'Suecia' },
  { label: 'Suiza', value: 'Suiza' },
  { label: 'Turquía', value: 'Turquia' },
  { label: 'Uruguay', value: 'Uruguay' },
  { label: 'Venezuela', value: 'Venezuela' },
];

export const countriesWithPhone = [
  { label: 'Argentina (+54)', value: '54' },
  { label: 'Alemania (+49)', value: '49' },
  { label: 'Andorra (+376)', value: '376' },
  { label: 'Aruba (+297)', value: '297' },
  { label: 'Australia (+61)', value: '61' },
  { label: 'Austria (+43)', value: '43' },
  { label: 'Bahamas (+1(242))', value: '1(242)' },
  { label: 'Belgica (+32)', value: '32' },
  { label: 'Belice (+501)', value: '501' },
  { label: 'Bolivia (+591)', value: '591' },
  { label: 'Brasil (+55)', value: '55' },
  { label: 'Canadá (+1)', value: '1' },
  { label: 'Catar (+974)', value: '974' },
  { label: 'Chile (+56)', value: '56' },
  { label: 'China (+86)', value: '86' },
  { label: 'Colombia (+57)', value: '57' },
  { label: 'Costa Rica (+506)', value: '506' },
  { label: 'Croacia (+385)', value: '385' },
  { label: 'Cuba (+53)', value: '53' },
  { label: 'Ecuador (+593)', value: '593' },
  { label: 'Egipto (+20)', value: '20' },
  { label: 'España (+34)', value: '34' },
  { label: 'Estados Unidos (+1)', value: '1' },
  { label: 'Filipinas (+63)', value: '63' },
  { label: 'Francia (+33)', value: '33' },
  { label: 'Grecia (+30)', value: '30' },
  { label: 'Guatemala (+502)', value: '502' },
  { label: 'Haití (+509)', value: '509' },
  { label: 'Hong Kong (+852)', value: '852' },
  { label: 'India (+91)', value: '91' },
  { label: 'Iran (+98)', value: '98' },
  { label: 'Iraq (+964)', value: '964' },
  { label: 'Irlanda (+353)', value: '353' },
  { label: 'Israel (+972)', value: '972' },
  { label: 'Italia (+39)', value: '39' },
  { label: 'Jamaica (+1(876))', value: '1(876)' },
  { label: 'Japon (+81)', value: '81' },
  { label: 'Libano (+961)', value: '961' },
  { label: 'Malta (+356)', value: '356' },
  { label: 'Marruecos (+212)', value: '212' },
  { label: 'Mexico (+52)', value: '52' },
  { label: 'Nicaragua (+505)', value: '505' },
  { label: 'Noruega (+47)', value: '47' },
  { label: 'Nueva Zelanda (+64)', value: '64' },
  { label: 'Paises Bajos (+31)', value: '31' },
  { label: 'Panama (+507)', value: '507' },
  { label: 'Paraguay (+595)', value: '595' },
  { label: 'Peru (+51)', value: '51' },
  { label: 'Polonia (+48)', value: '48' },
  { label: 'Portugal (+351)', value: '351' },
  { label: 'Puerto Rico (+1(787))', value: '1(787)' },
  { label: 'Inglaterra (+44)', value: '44' },
  { label: 'Republica Dominicana (+1(809)', value: '1(809)' },
  { label: 'Rusia (+7)', value: '7' },
  { label: 'Sudafrica (+27)', value: '27' },
  { label: 'Suecia (+46)', value: '46' },
  { label: 'Suiza (+41)', value: '41' },
  { label: 'Turquía (+90)', value: '90' },
  { label: 'Uruguay (+598)', value: '598' },
  { label: 'Venezuela (+58)', value: '58' },
];
